import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { getTokenFromCookie } from './cookie';

// 后端 WebSocket 的接入点
const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;

let stompClient = null;

export const connectWebSocket = (onConnectedCallback) => {
    if (stompClient && stompClient.active) {
        if (onConnectedCallback) onConnectedCallback();
        return;
    }

    // 获取token并动态拼接
    const token = getTokenFromCookie();
    const params = new URLSearchParams();
    if (token) {
        params.append('token', token);
    } else {
        alert.error('please login first');
    }
    const urlWithParams = `${WEBSOCKET_URL}?${params.toString()}`;

    // 创建客户端
    stompClient = new Client({
        // 用 SockJS 创建WebSocket
        webSocketFactory: () => new SockJS(urlWithParams),

        // 连接成功时的回调
        onConnect: () => {
            console.log('WebSocket Connected via @stomp/stompjs');
            // 执行从外部传入的回调函数
            if (onConnectedCallback) {
                onConnectedCallback();
            }
        },

        // 连接失败时的回调
        onStompError: (frame) => {
            console.error('Broker reported error: ' + frame.headers['message']);
            console.error('Additional details: ' + frame.body);
        },

        // 关闭调试信息，避免在控制台输出过多内容
        debug: (str) => {
            console.log(new Date(), str);
        },

        // 可以设置重连延迟
        reconnectDelay: 5000,
    });

    // 激活连接
    stompClient.activate();
};

export const subscribe = (topic, onMessageReceived) => {
    if (stompClient && stompClient.active) {
        return stompClient.subscribe(topic, (message) => {
            onMessageReceived(JSON.parse(message.body));
        });
    } else {
        console.error("Cannot subscribe, WebSocket not active.");
    }
};

export const sendWebSocketMessage = (destination, body) => {
    if (stompClient && stompClient.active) {
        stompClient.publish({
            destination: destination,
            body: JSON.stringify(body),
        });
    } else {
        console.error("Cannot send message, WebSocket not active.");
        alert('网络连接已断开，请刷新页面重试。');
    }
};

export const disconnectWebSocket = () => {
    if (stompClient && stompClient.active) {
        stompClient.deactivate();
        console.log('WebSocket Disconnected');
    }
};